import { Formik } from "formik";
import Loader from "../../loader";
import StepsDots from "../../form/StepsDots";
import { useNavigate } from "react-router-dom";
import ErrorMessage from "../../form/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import { findAJobPaths } from "../../../routes/find-a-job";
import { profileStep4Schema } from "../../../utils/schema";
import { profileStep4Submit } from "../../../redux/features/find-a-job/actions/authAction";
import { setIsFindAJobModal } from "../../../redux/features/find-a-job/reducers/authReducer";
import {
  getFreelancerFormData,
  clearFreelancerFormData,
} from "../../../utils/pip";
import { jobTypes } from "../../../utils/data";

const ProfileSetupStep4 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { subLoading } = useSelector((state) => state.freelancer.auth);
  const savedData = getFreelancerFormData()?.profileStep4 || {};
  const handleStep4 = (values) => {
    const callback = (res) => {
      if (res?.success) {
        clearFreelancerFormData();
        dispatch(setIsFindAJobModal(false));
        navigate(findAJobPaths?.Dashboard);
      }
    };

    dispatch(profileStep4Submit({ payload: values, callback }));
  };

  if (subLoading) {
    return <Loader />;
  }
  return (
    <div class="modal-body pe-0">
      <section class="ct_signup_main py-3">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
              <div class="ct_signup_left_img">
                <img
                  src="../assets/img/setp_6_freelance_img_left.png"
                  alt=""
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div class="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0 ">
              <div class="ct_signup_right_content px-5 ct_custom_scroll">
                {/* <div
                  className="ct_back_top_btn"
                  onClick={() => {
                    dispatch(setRegisterStep("profileStep3"));
                  }}
                >
                  <i class="fa-solid fa-arrow-left"></i>
                </div> */}
                <div class="ct_signup_logo ct_mb_34">
                  <img src="../assets/img/Nuvio_logo.png" alt="" />
                </div>
                <div class="mt-0 text-center">
                  <h2 class="ct_fs_32  mb-0 ct_darkblue_text">
                    Your Job Preferences
                  </h2>
                  <p className="mb-0 ct_fs_16 mt-2 ct_darkblue_text mx-auto">
                    Let us know your ideal job details location, role, and work
                    style.
                  </p>
                </div>
                <Formik
                  initialValues={savedData}
                  validationSchema={profileStep4Schema}
                  validateOnChange={true}
                  validateOnBlur={true}
                  enableReinitialize
                  onSubmit={(values, actions) => {
                    handleStep4(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    setTouched,
                  }) => (
                    <form onSubmit={handleSubmit} class="ct_mt_40">
                      <div className="row">
                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label class="mb-2 d-block ct_fs_14 ct_darkblue_text">
                              Job types you’re open to
                            </label>

                            {/* add active class when we click on button  */}
                            <div className="d-flex align-items-center gap-3">
                              {jobTypes?.map((item, idx) => {
                                return (
                                  <button
                                    type="button"
                                    key={idx}
                                    className={`ct_yellow_btn py-2 px-4 ct_job_type_btn  ct_outline_grey ${
                                      values?.job_type === item?.value
                                        ? "active"
                                        : ""
                                    }`}
                                    onClick={() => {
                                      setFieldValue("job_type", item?.value);
                                        setTouched(prev => ({ ...prev, job_type: true }));
                                    }}
                                  >
                                    {item?.label}
                                  </button>
                                );
                              })}
                            </div>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName={"job_type"}
                            />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label class="mb-3 d-block ct_fs_14 ct_darkblue_text">
                              Job Search Status
                            </label>
                            <div>
                              <div class="ct_radio-container ct_radio_container_yellow gap-0">
                                <div class="ct_radio-wrapper">
                                  <label class="ct_radio-button">
                                    <input
                                      id="option1"
                                      name="ct_radio-group"
                                      type="radio"
                                      value="AVAILABLE"
                                      checked={
                                        values.search_status === "AVAILABLE"
                                      }
                                      onChange={() =>
                                        setFieldValue(
                                          "search_status",
                                          "AVAILABLE"
                                        )
                                      }
                                    />
                                    <span class="ct_radio-checkmark"></span>
                                  </label>
                                </div>
                                <p className="mb-0 ct_fs_14 ct_darkblue_text">
                                  Available Now
                                </p>
                              </div>
                              <div class="ct_radio-container ct_radio_container_yellow gap-0 mt-3">
                                <div class="ct_radio-wrapper">
                                  <label class="ct_radio-button">
                                    <input
                                      id="option1"
                                      name="ct_radio-group"
                                      type="radio"
                                      value="WORKING"
                                      checked={
                                        values.search_status === "WORKING"
                                      }
                                      onChange={() =>
                                        setFieldValue(
                                          "search_status",
                                          "WORKING"
                                        )
                                      }
                                    />
                                    <span class="ct_radio-checkmark"></span>
                                  </label>
                                </div>
                                <p className="mb-0 ct_fs_14 ct_darkblue_text">
                                  Currently Working on a Project
                                </p>
                              </div>

                              <ErrorMessage
                                errors={errors}
                                touched={touched}
                                fieldName={"search_status"}
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label class="mb-2 d-block ct_fs_14 ct_darkblue_text">
                              Salary Preferences
                            </label>
                            <input
                              class="form-control ct_input"
                              placeholder="Salary preferences"
                              type="text"
                              name="salary_preference"
                              value={values.salary_preference || ""}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />

                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName={"salary_preference"}
                            />
                          </div>
                        </div>
                      </div>
                      <div class="text-center mt-2">
                        <button
                          type="submit"
                          // onClick={(e) => goTo(e, coachPaths.CoachSignUpStep2)}
                          onClick={handleSubmit}
                          class="ct_yellow_btn  w-100 mx-auto"
                        >
                          Continue
                        </button>
                      </div>
                      <StepsDots steps={[1, 2, 3, 4]} activeStep={4} />
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProfileSetupStep4;
